<template>
  <v-app id="app" :style="{'background-color':$vuetify.theme.themes.light.primary +' !important'}">
    <logos
      :src="$headerLogo"
      alt="Idonia"
    ></logos>
    <v-main>
    <register-form v-if="canRegister"></register-form>
    <v-card v-else class="pb-1">
      <v-card-text>{{$tf('RegistrationClosed')}}{{$tf('Support Team')}}</v-card-text>
    </v-card>
    </v-main>
  </v-app>
</template>

<script>
import RegisterForm from '../../components/RegisterForm.vue'
import Logos from '../../components/Logos'
import version from '../../mixins/version'

export default {
  name: 'app',
  mixins: [version],
  components: {
    RegisterForm, Logos
  },
  computed: {
    canRegister () {
      return this.$allowSelfRegistration ||
        this.$oidcRegistrationMode === 'only_oidc_email' ||
        this.$oidcRegistrationMode === 'grant'
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: #ddd;
}

::-webkit-scrollbar-thumb {
  background: #666;
}
</style>
